import React from 'react';
import PropTypes from 'prop-types';
import PercentageInputField from 'components/form/InputFields/PercentageInputField';

const RenderPercentageInputField = (props) => {
    const {
        containerStyle,
        className,
        defaultValue,
        disabled,
        fullWidth,
        input: { name, onBlur, onChange, onFocus, value },
        label,
        max,
        meta: { touched, error },
        min,
        placeholder,
        style,
    } = props;

    return (
        <PercentageInputField
            className={ className }
            containerStyle={ containerStyle }
            defaultValue={ defaultValue }
            disabled={ disabled }
            errorText={ touched && error }
            fullWidth={ fullWidth }
            hintText={ placeholder }
            label={ label }
            name={ name }
            max={ max }
            min={ min }
            onBlur={ onBlur }
            onChange={ (event) => {
                onChange(event.target.value);
            } }
            onFocus={ onFocus }
            style={ style }
            type='number'
            value={ value }
        />
    );
};

RenderPercentageInputField.defaultProps = {
    containerStyle: {},
    fullWidth: false,
    max: '100',
    min: '0',
    type: 'text',
};

RenderPercentageInputField.propTypes = {
    containerStyle: PropTypes.object,
    className: PropTypes.string,
    defaultValue: PropTypes.string,
    disabled: PropTypes.bool,
    fullWidth: PropTypes.bool,
    input: PropTypes.shape({
        name: PropTypes.string.isRequired,
        onBlur: PropTypes.func,
        onChange: PropTypes.func,
        onDragStart: PropTypes.func,
        onDrop: PropTypes.func,
        onFocus: PropTypes.func,
        value: PropTypes.value,
    }).isRequired,
    label: PropTypes.string.isRequired,
    max: PropTypes.string,
    meta: PropTypes.shape({
        error: PropTypes.oneOfType([
            PropTypes.func,
            PropTypes.string,
        ]),
        touched: PropTypes.bool,
    }),
    min: PropTypes.string,
    placeholder: PropTypes.string,
    style: PropTypes.object,
};

export default RenderPercentageInputField;



// WEBPACK FOOTER //
// ./src/components/form/InputFields/RenderPercentageInputField.js